.vc-divider {
    height: 1px;
    width: 100%;
    border: none;
    border-top: 1px solid var(--border-subtle);
}